import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getTermFromState } from '../../redux/selectors/i18n';
import { getLocationName } from '../../redux/selectors/dma';
import { openZipModalUserAction } from '../../redux/actions/zipCode';
import {
  StyledLocationWrapper,
  StyledLocationLabel,
  StyledOpenLocationButton
} from './styles';

/**
 * Location Component displays the city name and city state as a
 * button that can be clicked to open the zip code modal
 */
class Location extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    locationValue: PropTypes.string.isRequired,
    changeLocation: PropTypes.func.isRequired,
    disabled: PropTypes.bool
  };
  static defaultProps = {
    disabled: false
  }
  constructor(props) {
    super(props);
    this.onChangeLocation = this.onChangeLocation.bind(this);
  }

  /**
   * Changes the location based on the user having entered a new zip code
   */
  onChangeLocation(e) {
    e.preventDefault();
    const { changeLocation } = this.props;
    changeLocation();
  }
  render() {
    const { label, locationValue, disabled } = this.props;
    return (
      <StyledLocationWrapper className="location row">
        <StyledLocationLabel className="location-label">{ label }</StyledLocationLabel>
        <StyledOpenLocationButton disabled={disabled} onClick={this.onChangeLocation} className="location-open">{ locationValue }</StyledOpenLocationButton>
      </StyledLocationWrapper>
    );
  }
}

const mapStateToProps = state => ({
  label: getTermFromState(state, 'personalizePanel.locationText'),
  locationValue: getLocationName(state)
});

const mapDispatchToProps = dispatch => ({
  changeLocation: bindActionCreators(openZipModalUserAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Location);



/** WEBPACK FOOTER **
 ** ./src/components/Location/index.js
 **/